import { gql } from '@apollo/client';

export const GET_EVM_NFTS_BY_OWNER_QUERY = gql`
  query GetEvmNFTsByOwners($data: GetEvmNFTsByOwnersInput!) {
    getEvmNFTsByOwners(data: $data) {
      name
      owner
      tokenId
      tokenType
      tokenUri
      structuredAttributes
      balance
      description
    }
  }
`;
